import React from 'react'
import * as Styles from './container.module.scss'

export function Container({ children }) {
  return <div className={Styles.container}>{children}</div>
}
